import { JOB_SEARCHING_FOR } from '@/constants';
import { AmplitudeEvent, trackAmplitudeEvent } from '@/lib/analyticsHelper';
import { type seoSegmentationListingPage_seoSegmentationSearchResults_SEOSegmentationSearchResultsSuccess as SEOSegmentationSearchResults } from '@/__generated__/seoSegmentationListingPage';
import { SEOSegmentationSearchingFor } from '@/__generated__/globalTypes';

export interface TrackPageViewedEventParams {
  pageTitle: string;
  serviceIdForMember: string;
  amplitudeTestName: string;
  searchingFor: SEOSegmentationSearchingFor;
  pageType: string;
  seoSegmentationSearchResults: SEOSegmentationSearchResults;
}

export const trackPageViewedEvent = async ({
  pageTitle,
  serviceIdForMember,
  amplitudeTestName,
  searchingFor,
  pageType,
  seoSegmentationSearchResults,
}: TrackPageViewedEventParams) => {
  const isJobSegment = searchingFor in JOB_SEARCHING_FOR;

  const seoPageType = () => {
    if (isJobSegment) {
      return 'Provider SEO page';
    }
    if (seoSegmentationSearchResults.providerSearchResults.length > 0) {
      return 'SMB SEO page';
    }
    return 'Seeker SEO page';
  };

  const amplitudeDataForPageViewed = {
    seo_page_title: pageTitle,
    seo_page_type: seoPageType(),
    service_id_for_member: serviceIdForMember,
    page_template: pageType,
  };

  const amplitudeDataForTestExposure = {
    test_name: amplitudeTestName,
    test_variant: '1',
    service_id_for_member: serviceIdForMember,
    page_template: pageType,
  };

  if (amplitudeTestName) {
    await trackAmplitudeEvent(AmplitudeEvent.testExposure, amplitudeDataForTestExposure);
  }
  await trackAmplitudeEvent(AmplitudeEvent.seoPageViewed, amplitudeDataForPageViewed);
};
